import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useBounds } from 'hooks/useBounds';
import { useCurrencyFormatter } from 'hooks/useCurrencyFormatter';
import { PromotionSummary } from 'lib/util/productShape';
import { getPromotionTitleText } from 'lib/util/promotionTextHelpers';
import { printPriceTitle } from 'lib/util/util';

interface Props {
  expanded?: boolean;
  onClickExpanded?: () => void;
  promotions: PromotionSummary[];
}

export const PromotionPanel = ({ expanded, onClickExpanded, promotions }: Props) => {
  const { i18n, t } = useTranslation();
  const locale = i18n.language;

  const [priceListRef, priceListRefBounds] = useBounds<HTMLUListElement>();

  const shouldTruncate = !expanded && priceListRefBounds.height > 170;

  const containerDivClasses = ['widget-calendar__promotion'];
  const buttonDivClasses = ['widget-calendar__promotion__more'];
  if (shouldTruncate) {
    containerDivClasses.push('is-close');
    buttonDivClasses.push('is-close');
  }

  const currencyFormatter = useCurrencyFormatter();

  return (
    <div className={containerDivClasses.join(' ')}>
      <ul ref={priceListRef} className="widget-calendar__promotion__list">
        {promotions.map((promo, idx) => (
          <li key={idx} className="widget-calendar__promotion__list__item">
            <div className="widget-calendar__promotion__list__item__header">
              <img alt="special" src="/static/images/ic_special.svg" />
              <p>{getPromotionTitleText(promo, t, locale, currencyFormatter)}</p>
            </div>
            <ul className="widget-calendar__promotion__list__item__body">
              {promo.prices.map((price, idx) => (
                <li key={idx} className="widget-calendar__promotion__list__item__body__item">
                  <p className="widget-calendar__promotion__list__item__body__item__ttl">
                    {printPriceTitle(price, t)}
                  </p>
                  <p className="widget-calendar__promotion__list__item__body__item__price">
                    {price.amount !== price.amountAfterChargeOrDiscount && (
                      <span className="normal">{currencyFormatter.format(price.amount)}</span>
                    )}
                    <span className="discount">
                      {currencyFormatter.format(price.amountAfterChargeOrDiscount)}
                    </span>
                  </p>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
      {shouldTruncate && (
        <div className={buttonDivClasses.join(' ')}>
          <button
            type="button"
            className="widget-calendar__promotion__more__btn maincolor-txt maincolor-border"
            onClick={() => onClickExpanded?.()}
          >
            {t('Show More')}
          </button>
        </div>
      )}
    </div>
  );
};
